import {
  IGetOrdersResponse,
  IGetOrdersParams,
  IPayOrderParams,
  IPayOrderResponse,
  IUpdateOrderStatusParams,
  IUpdateOrderStatusResponse,
  IPayOrdersParams,
} from "../types/order";
import axios from "./axios";

const cacheBuster = (string: string) => `${string}?timestamp=${Date.now()}`;

export async function getOrders(params: IGetOrdersParams) {
  const resp = await axios.get(cacheBuster("api/m0/order/"), {
    params,
  });
  return resp.data.data as IGetOrdersResponse;
}

export async function payOrder(params: IPayOrderParams) {
  const resp = await axios.post("api/m0/order", params);
  return resp.data as IPayOrderResponse;
}

export async function payOrders(params: IPayOrdersParams) {
  const resp = await axios.post("api/m1/order", params);
  return resp.data as IPayOrderResponse;
}

export async function updateOrderStatus(params: IUpdateOrderStatusParams) {
  const resp = await axios.put("api/m0/order", params);
  return resp.data as IUpdateOrderStatusResponse;
}
